export enum EmailIntegrationType {
  SendOnly = 'SendOnly',
  SendAndRead = 'SendAndRead',
}
